<template lang="pug">
BriqTable
  thead
    th From Date
    th To Date
    th Product 
    th Resource 
    th Quantity
    th 
  tbody
    template(v-for="item in logData")
      tr.audit-trail-data-col(@click="item.showDetals = !item.showDetals")
        td {{ prettyDate(item.FromDateTimeUTC) }}
        td {{ prettyDate(item.ToDateTimeUTC) }}
        td {{ item.ProductName }}
        td {{ item.ProductGroupName }}
        td {{ item.ProductQuantity }}
        td
          .show-detals-btn(:class="item.showDetals ? `rotate-180` : ``")
            BriqIcon(name="icon-input-arrow-down-icon")
      tr(v-if="item.showDetals")
        td(colspan="6") 
          .logs-details-table
            BriqTable
              thead
                th Source Availability Items
              tbody
                tr
                  td 
                    textarea(readonly) {{ item.SourceAvailabilityItems }}        
</template>

<script>
import logTablesMixin from './logTablesMixin.js'

export default {
  name: 'TimeslotProvenanceTable',
  mixins: [logTablesMixin],
  props: {
    logData: {
      type: Array,
      required: true,
    },
  },
}
</script>

<style scoped lang="stylus">
@import '~@v/components-global/BriqViewAuditTrail/tableStyle.styl'
</style>
